import React from 'react';

// Importing images for each service
import serviceImg1 from '../assets/img/1.png';
import serviceImg2 from '../assets/img/2.png';
import serviceImg3 from '../assets/img/003.png';
import serviceImg4 from '../assets/img/004.png';
import serviceImg5 from '../assets/img/05.png';
import serviceImg6 from '../assets/img/006.png';

function Services() {
  return (
    <div>
      <section className="services_page">

        <div className="sevices_page_wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h1><span>Services</span></h1>
              </div>
              <div className="col-md-6">
                <p>
                We combine creativity, technology, and precision to deliver bold, cinematic content that connects. Whether you’re launching a product or building a brand, we shape ideas into impactful visual experiences.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Section for each service */}
        <div className="sevices_page_wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="service_page_icon"><img src={serviceImg1} alt="Editing" /></div>
              </div>
              <div className="col-md-6">
                <h2 className="service_page_title">Commercials & Branded Films</h2>
                <p>
                High-end storytelling that captures attention and elevates brands.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="sevices_page_wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="service_page_icon"><img src={serviceImg2} alt="Color Grading" /></div>
              </div>
              <div className="col-md-6">
                <h2 className="service_page_title">Creative Direction & Concept Development</h2>
                <p>
                  From spark to script, we build creative leads
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="sevices_page_wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="service_page_icon"><img src={serviceImg3} alt="Sound" /></div>
              </div>
              <div className="col-md-6">
                <h2 className="service_page_title">Post-Production</h2>
                <p>
                World-class editing, color grading, sound, and finishing.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="sevices_page_wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="service_page_icon"><img src={serviceImg4} alt="VFX" /></div>
              </div>
              <div className="col-md-6">
                <h2 className="service_page_title">Motion Design & Animation
</h2>
                <p>
                  2D, 3D, and mixed media to bring stories to life with movement.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="sevices_page_wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="service_page_icon"><img src={serviceImg5} alt="Animation" /></div>
              </div>
              <div className="col-md-6">
                <h2 className="service_page_title">Short-Form Content</h2>
                <p>
                Tailored visuals that cut through noise and drive engagement.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="sevices_page_wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="service_page_icon"><img src={serviceImg6} alt="Branding" /></div>
              </div>
              <div className="col-md-6">
                <h2 className="service_page_title">Art Direction
</h2>
                <p>
                Campaign imagery and branded visuals with cinematic flair.

                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
